"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const translate_1 = require("./translate");
let InaxTranslatePipe = class InaxTranslatePipe {
    constructor(_translateService) {
        this._translateService = _translateService;
    }
    transform(value, ...options) {
        return this._translateService.translate(value, options);
    }
};
InaxTranslatePipe = __decorate([
    core_1.Pipe({ name: 'translate' }),
    __metadata("design:paramtypes", [translate_1.InaxTranslateService])
], InaxTranslatePipe);
exports.InaxTranslatePipe = InaxTranslatePipe;
